/**
 * Created by Ning Jiang on 2021-06-21.
 */

import {TombstoneRipGameAssets} from "../../../TombstoneRipGameAssets";
import {TombstoneRip} from "../../../TombstoneRip";

export class WaysWonTextContainer extends PIXI.Container {

    private readonly _wayWonTextures:string[] = ["wayWon", "waysWon"];

    private _waysWonNumber:PIXI.BitmapText;
    private _waysWonText:PIXI.Sprite;

    constructor() {
        super();

        this._waysWonText = new PIXI.Sprite();
        // this._wayWonTexts.forEach((text:string) => {
        //     this._waysWonText.addSprites({
        //         name : text,
        //         textures : TombstoneRip.assetLoader.getTextures(`initialwin/ways/${text}`),
        //         anchor : new PIXI.Point(1, 0.5)
        //     });
        // });
        this._waysWonText.anchor.set(1, 0.5);
        this._waysWonText.scale.set(0.5);
        this.addChild(this._waysWonText);

        this._waysWonNumber = new PIXI.BitmapText("", {
            fontName : TombstoneRipGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 30,
            tint : 0xffffff
        });
        (<PIXI.Point>this._waysWonNumber.anchor).set(0, 0.9);
        this.addChild(this._waysWonNumber);
    }

    public show(winWaysWon:number):void {
        this._waysWonNumber.text = "" + winWaysWon;
        const textureName:string = winWaysWon === 1 ? this._wayWonTextures[0] : this._wayWonTextures[1];
        this._waysWonText.texture = TombstoneRip.assetLoader.getTextures(`initialwin/ways/${textureName}`)[0];
        this.updatePositions();
    }

    private updatePositions():void {
        const space = 10;
        this._waysWonNumber.updateTransform();
        const totalWidth:number = this._waysWonNumber.width + this._waysWonText.width + space;
        this._waysWonNumber.x = -totalWidth / 2;
        this._waysWonText.x = totalWidth / 2;
    }

    public setColor(color:number):void {
        this._waysWonNumber.tint = color;
        this._waysWonText.tint = color;
    }
}